import { formatPhDate } from '@/lib/phDate';

interface EntryRow {
  created_at: string;
  technician_id?: string | null;
  data_source?: string | null;
}

/**
 * A back-filled entry (#366): its author entered it on a later Philippine calendar day than the
 * day it is for. Derived, never stored. Imports are excluded (their created_at is the import
 * time, which would mark every imported day late), and so are rows with no author.
 */
export function isLateEntry(row: EntryRow, entryDate: string): boolean {
  if (!row.technician_id || row.data_source === 'imported') return false;
  return formatPhDate(new Date(row.created_at)) > entryDate;
}
